<template>
  <div>
    <section id="nav">
      <nav class="navbar navbar-default navbar-trans navbar-expand-lg fixed-top">
        <div class="container">
          <button type="button" data-target="#navbarDefault" aria-controls="navbarDefault"
                  aria-expanded="false" aria-label="Toggle navigation" class="navbar-toggler collapsed" @click="nav =
                   !nav">
            <span></span><span></span><span></span></button>
          <router-link to="/" class="router-link-exact-active router-link-active"><img
            src="/static/img/logo_wide.png"
            class="lasr-logo"></router-link>
<!--          <button type="button" data-toggle="collapse" data-target="#navbarTogglerDemo01" aria-expanded="false"-->
<!--                  class="btn btn-link nav-search navbar-toggle-box-collapse d-md-none"></button>-->
          <div id="navbarDefault" class="navbar-collapse justify-content-center collapse" :class="nav ? 'show' : null">
            <ul class="navbar-nav">
              <li v-for="(l, m) in menu" @click="nav = false" >
                <router-link  data-toggle="collapse"  :to="'/' + l" class="nav-link"
                :class="$route.name ===
                 m ?
                'active' : null">
                  {{m}}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </section>
    <div class="container">
      <router-view/>
    </div>
    <section class="section-footer">
      <div class="container">
        <div class="row">
          <div class="col-sm-12 col-md-4">
            <div class="widget-a">
              <div class="w-header-a"><h3 class="w-title-a text-brand">LASR</h3></div>
              <div class="w-body-a">
                <div><strong>Carissa Cascio, PhD</strong></div>
                <div>Vanderbilt University Medical Center</div>
                <div>Village at Vanderbilt</div>
                <div>Nashville, TN 37212</div>
              </div>
              <div class="w-footer-a">
                <ul class="list-unstyled">
                  <li class="color-a"><span class="color-text-a">Phone </span><a href="tel:6159367220">(615)
                    936-7220</a></li>
                  <li class="color-a"><span class="color-text-a">Email </span><a target="_blank"
                                                                                 href="mailto: autismlasr@vumc.org"> autismlasr@vumc.org</a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 section-md-t3">
            <div class="widget-a">
              <div class="w-body-a">
                <div class="w-body-a">
                  <ul class="list-unstyled">
                    <li class="item-list-a" v-for="(link, title) in footer_left"><i class="fa fa-angle-right"></i><a
                      :href="link" target="_blank">{{title}}</a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 section-md-t3">
            <div class="widget-a">
              <div class="w-body-a">
                <ul class="list-unstyled">
                  <li class="item-list-a" v-for="(link, title) in footer_right"><i class="fa fa-angle-right"></i><a
                    :href="link" target="_blank">{{title}}</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="copyright-footer"><p class="copyright color-text-a">
              © Copyright
              <span class="color-a">Carissa Cascio - Vanderbilt University Medical Center</span> All Rights Reserved.
            </p></div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  export default {
    name: 'App',
    data: function () {
      return {
        nav: false,
        menu: {
          People: "people",
          Studies: "studies",
          Research: "research",
          Publications: "publications",
          Press: "press",
          Resources: "resources",
          "Get Involved": "get-involved"
        },
        footer_left: {
          "Research Gate": "https://www.researchgate.net/profile/Carissa_Cascio",
          Twitter: "https://twitter.com/AutismLASR"
        },
        footer_right: {
          "Vanderbilt Psychiatric Neuroimaging Program": "https://www.vumc.org/psychiatric-neuroimaging/",
          "Vanderbilt Department of Psychiatry": "https://www.vumc.org/psychiatry/welcome",
          "Vanderbilt University Medical Center": "https://www.vumc.org/"
        }
      }
    }
  }
</script>

<style>
  @import './assets/style.css';
</style>



// WEBPACK FOOTER //
// src/App.vue